import React from "react";

const SeparatorBlock = ({}) => {
  return <div className="separator-block w-100 mt2 pb2 mt3-l pb3-l" />;
};

export default SeparatorBlock;



// WEBPACK FOOTER //
// ./src/components/Blocks/SeparatorBlock.js